import {
  Component,
  OnDestroy,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { BusinessTypeEnum } from '../../../enums/BusinessTypeEnum';


@Component({
  selector: 'app-colabs-manager',
  templateUrl: './colabs-manager.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class ColabsManagerComponent extends PageBase implements OnDestroy {

  private establishmentId: string;
  private companyId: string;
  public typeBusiness: string;
  public downloadUserAccounts: boolean;

  private routeParamsSubscription: Subscription;
  public activatedRoute: string;
  public myPasswordConfirmation: string;

  constructor(private translate: TranslateService,
              private toasterService: ToasterService,
              private request: RequestsServices,
              private vcr: ViewContainerRef,
              private route: ActivatedRoute,
              private router: Router,
              private storage: StorageService,
              private userService: UserService) {
    super();

    const languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');


    const loggedAccount = this.userService.getLoggedAccount();
    this.typeBusiness = this.userService.getTypeAccount();
    this.downloadUserAccounts = loggedAccount.download_user_accounts;

    if (this.typeBusiness === BusinessTypeEnum.Company) {
      this.companyId = loggedAccount.id;
    } else if (this.typeBusiness === BusinessTypeEnum.Establishment) {
      this.establishmentId = loggedAccount.id;
    } else {
      alert('Falha ao recuperar dados.');
    }


    // The code block below reset the component state when the user clicks at the menu even it is the same component
    // Override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.activatedRoute = event.url;
      }
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        this.activatedRoute = event.url;
        // Scroll the page back to top
        window.scrollTo(0, 0);
     }

    });

  }

  public ngOnDestroy(): void {
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
  }

  public confirmPasswordExport(): void {
    const user = this.userService.getLoggedUser();
    const userAccessToken = user.accessToken;
    this.request.download('customers/download/csv?companyId=' + this.companyId + '&access_token=' + userAccessToken);
  }
}
